var service = function(C) {
  var productTypePlaceholders = {
    'null': C.IMAGE_PATHS['product_type_beer.png'],
    '1': C.IMAGE_PATHS['product_type_beer.png'],
    '2': C.IMAGE_PATHS['product_type_wine.png'],
    '3': C.IMAGE_PATHS['product_type_liquor.png'],
    '4': C.IMAGE_PATHS['product_type_other.png']
  };

  var isMarketingImage = function(obj) {
    return obj.cloudinary_image_url && (
      _.includes(obj.cloudinary_image_url, 'collection-entries')
      || _.includes(obj.cloudinary_image_url, 'content-cards')
    );
  }

  var isDistributorImage = function(obj) {
    return obj.cloudinary_image_url && _.includes(obj.cloudinary_image_url, 'distributors');
  }

  var imgSrc = function(obj, width, height) {
    if (!obj) {
      return C.IMAGE_PATHS['product_type_other.png']
    }

    var host = C.CLOUDINARY.host;
    var bucket = C.CLOUDINARY.bucket;
    var url = "//" + host + "/" + bucket + "/image/upload/";
    var parts = [];

    if (isMarketingImage(obj)) {
      parts = ['q_auto', 'f_auto'];
    } else if (isDistributorImage(obj)) {
      url += "e_trim/";
      parts = ['c_fit'];
      if (height) { parts.push("h_" + height); }
      if (width) { parts.push("w_" + width); }
    } else {
      url += "e_trim/";
      parts = ['c_lpad'];
      if (width) { parts.push("w_" + width); }
      if (height) { parts.push("h_" + height); }
    }

    url += parts.join(',');

    if (obj.cloudinary_image_url) { return url + obj.cloudinary_image_url; }

    if (obj.image_version) {
      if (obj.override_image) { // collection entries image override
        url += "/v" + obj.image_version +
          '/collection-entries/' + obj.override_image;
      } else if (obj.discount_override_image) { // discounts
        url += "/v" + obj.image_version +
          '/discounts/' + obj.discount_override_image;
      } else if (_.get(obj, 'distributor_info.discount_image_info')) { // discounts
        url += "/v" + obj.distributor_info.discount_image_info.image_version +
          '/discounts/' + obj.distributor_info.discount_image_info.discount_override_image;
      } else if (obj.content_type) { // content cards
        url += "/v" + obj.image_version +
          "/content-cards/" + obj.image_name;
      } else { // regular product lines
        url += "/v" + obj.image_version +
          "/product-lines/" + obj.image_name;
      }
      return url;
    } else {
      return productTypePlaceholders[obj.product_type_id] || C.IMAGE_PATHS['icons/photo-placeholder.svg']
    }
  }

  // from https://stackoverflow.com/questions/24912021/convert-a-image-url-to-pdf-using-jspdf
  var getDataUri = function(url) {
    return new Promise(resolve => {
      var image = new Image();
      image.setAttribute('crossOrigin', 'anonymous'); //getting images from external domain

      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = this.naturalWidth;
        canvas.height = this.naturalHeight;

        //next three lines for white background in case png has a transparent background
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = '#fff';  /// set white fill style
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        canvas.getContext('2d').drawImage(this, 0, 0);
        resolve(canvas.toDataURL('image/jpeg'));
      };
      image.src = url;
    });
  }

  return {
    imgSrc: imgSrc,
    getDataUri: getDataUri
  }
};

service.$inject = ['C'];

tiz.service('ProductImageSrc', service);
